import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Rotayı sadece belirtilen rollere açar; diğerlerini ana sayfaya yönlendirir.
// Rol adları DashboardLayout'taki user.role değerleriyle aynı: "SysAdmin", "Yönetici", "Öğretmen", "Öğrenci".
// Bu sadece arayüz koruması: asıl yetki kontrolü backend'de yapılmalı (bkz. BULGULAR.md G10).
//   <Route path="school/teacherlist" element={<RequireRole roles={["Yönetici"]}><SchoolTeacherList /></RequireRole>} />
const RequireRole = ({ roles, children }) => {
    const { user } = useAuth();

    if (!user) return <Navigate to="/auth/login" replace />;
    if (!roles.includes(user.role)) return <Navigate to="/" replace />;

    return children;
};

export default RequireRole;
